import ReactTooltip from "react-tooltip";

export default function Box({ information }) {
  return (
    <div className="user-management-container text-center">
      <ReactTooltip id="btn" />

      <div className="user-information-container  d-flex my-2   flex-sm-row flex-column   flex-wrap">
        <div
          className={` ${
            information[3] == undefined
              ? ""
              : information[3][1] == "فعال" ||
                information[3][1] == "فعال (رفع مسدودی)"
              ? ""
              : "bg-secondary"
          } card-item-tabs d-flex flex-wrap w-100 `}
        >
          {information.map((value, index) => {
            return (
              <div key={index}>
                <div className="title">{value[0]}</div>
                <div className="description  mt-2 mx-auto">{value[1]}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
